<template>
    <section class="py-8 w-full bg-white lg:py-16">
        <div class="px-6 mx-auto max-w-5xl">

            <!-- Title -->
            <h2 class="mb-6 text-2xl font-extrabold text-center lg:text-left lg:mb-12 font-ww-bold md:text-3xl xl:text-42">
                What Real Customers Are Saying*
            </h2>

            <!-- Testimonials -->
            <div class="grid gap-x-4 gap-y-4 mb-6 lg:gap-x-8 md:grid-cols-2">
                <!-- Card 1 -->
                <article class="p-4 text-sm leading-relaxed bg-white rounded-sm border border-gray-200 md:p-8 xl:p-12">
                    <!-- stars -->
                    <svg class="mx-auto md:mx-0" width="113" height="16" viewBox="0 0 113 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <rect width="16.8888" height="15.9999" fill="url(#pattern0_3179_3872)" />
                        <rect x="24" width="16.8888" height="15.9999" fill="url(#pattern1_3179_3872)" />
                        <rect x="48" width="16.8888" height="15.9999" fill="url(#pattern2_3179_3872)" />
                        <rect x="72" width="16.8888" height="15.9999" fill="url(#pattern3_3179_3872)" />
                        <rect x="96" width="16.8888" height="15.9999" fill="url(#pattern4_3179_3872)" />
                        <defs>
                            <pattern id="pattern0_3179_3872" patternContentUnits="objectBoundingBox" width="1"
                                height="1">
                                <use xlink:href="#image0_3179_3872" transform="scale(0.0526316 0.0555556)" />
                            </pattern>
                            <pattern id="pattern1_3179_3872" patternContentUnits="objectBoundingBox" width="1"
                                height="1">
                                <use xlink:href="#image0_3179_3872" transform="scale(0.0526316 0.0555556)" />
                            </pattern>
                            <pattern id="pattern2_3179_3872" patternContentUnits="objectBoundingBox" width="1"
                                height="1">
                                <use xlink:href="#image0_3179_3872" transform="scale(0.0526316 0.0555556)" />
                            </pattern>
                            <pattern id="pattern3_3179_3872" patternContentUnits="objectBoundingBox" width="1"
                                height="1">
                                <use xlink:href="#image0_3179_3872" transform="scale(0.0526316 0.0555556)" />
                            </pattern>
                            <pattern id="pattern4_3179_3872" patternContentUnits="objectBoundingBox" width="1"
                                height="1">
                                <use xlink:href="#image0_3179_3872" transform="scale(0.0526316 0.0555556)" />
                            </pattern>
                            <image id="image0_3179_3872" width="19" height="18" preserveAspectRatio="none"
                                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAABxUlEQVQ4jWL838hACJxlYGBQYWBguMPAwGCMUzEDAwMAAAD//2IiYFIYAwODEQMDAx+UBvGxAwYGBgAAAAD//yJkWBcBPgIwMDAAAAAA///CZ1goAwODPJoYiA8SxwQMDAwAAAAA///CZhgLAwODAQMDQz8OPSBxkDxIHQIwMDAAAAAA//980DEJACAAAMFLIYJJBDPY0iyO1nA2gIjg7PrT8TcUVATk9yd+xAkDEwsdG+0AAAD//wLF5n88GokHDAwMAAAAAP//AnnzNlVMYmC4DQAAAP//AhlmxsDAcJNCg24yMDCYAQAAAP//Ahn2gYGBwYQCA0H6TBgYGD4AAAAA//+CxeYXqMA5Eg0CqQfp+8LAwMAAAAAA//9CThoggWgSDQOpBxvEwMDAAAAAAP//Qk9nAiQahlDPwMAAAAAA//9CN8yJRMMQ6hkYGAAAAAD//0I3TIZEwxDqGRgYAAAAAP//QjfMFosGUAqvgtLoAKGegYEBAAAA//9CN0wYif2QgYEhiIGBwYqBgaEdSoP4IHFM9QwMDAAAAAD//0I3bDM0v01jYGDQZGBgWI8mD+KDxEHyIHUg9RDAwMAAAAAA//8DAHlhLFQe3TpUAAAAAElFTkSuQmCC" />
                        </defs>
                    </svg>
                    <div class="mt-3 mb-4 text-base text-center md:text-lg xl:text-xl font-ww-regular md:text-left">
                        “Literally the only coffee that doesn’t make me crash.”
                    </div>
                    <div class="text-base text-center md:text-lg xl:text-xl font-ww-regular md:text-left">– Sophia M.</div>
                </article>

                <article class="p-4 text-sm leading-relaxed bg-white rounded-sm border border-gray-200 md:p-8 xl:p-12">
                    <!-- stars -->
                    <svg class="mx-auto md:mx-0" width="113" height="16" viewBox="0 0 113 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <rect width="16.8888" height="15.9999" fill="url(#pattern0_3179_3872)" />
                        <rect x="24" width="16.8888" height="15.9999" fill="url(#pattern1_3179_3872)" />
                        <rect x="48" width="16.8888" height="15.9999" fill="url(#pattern2_3179_3872)" />
                        <rect x="72" width="16.8888" height="15.9999" fill="url(#pattern3_3179_3872)" />
                        <rect x="96" width="16.8888" height="15.9999" fill="url(#pattern4_3179_3872)" />
                        <defs>
                            <pattern id="pattern0_3179_3872" patternContentUnits="objectBoundingBox" width="1"
                                height="1">
                                <use xlink:href="#image0_3179_3872" transform="scale(0.0526316 0.0555556)" />
                            </pattern>
                            <pattern id="pattern1_3179_3872" patternContentUnits="objectBoundingBox" width="1"
                                height="1">
                                <use xlink:href="#image0_3179_3872" transform="scale(0.0526316 0.0555556)" />
                            </pattern>
                            <pattern id="pattern2_3179_3872" patternContentUnits="objectBoundingBox" width="1"
                                height="1">
                                <use xlink:href="#image0_3179_3872" transform="scale(0.0526316 0.0555556)" />
                            </pattern>
                            <pattern id="pattern3_3179_3872" patternContentUnits="objectBoundingBox" width="1"
                                height="1">
                                <use xlink:href="#image0_3179_3872" transform="scale(0.0526316 0.0555556)" />
                            </pattern>
                            <pattern id="pattern4_3179_3872" patternContentUnits="objectBoundingBox" width="1"
                                height="1">
                                <use xlink:href="#image0_3179_3872" transform="scale(0.0526316 0.0555556)" />
                            </pattern>
                            <image id="image0_3179_3872" width="19" height="18" preserveAspectRatio="none"
                                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAABxUlEQVQ4jWL838hACJxlYGBQYWBguMPAwGCMUzEDAwMAAAD//2IiYFIYAwODEQMDAx+UBvGxAwYGBgAAAAD//yJkWBcBPgIwMDAAAAAA///CZ1goAwODPJoYiA8SxwQMDAwAAAAA///CZhgLAwODAQMDQz8OPSBxkDxIHQIwMDAAAAAA//980DEJACAAAMFLIYJJBDPY0iyO1nA2gIjg7PrT8TcUVATk9yd+xAkDEwsdG+0AAAD//wLF5n88GokHDAwMAAAAAP//AnnzNlVMYmC4DQAAAP//AhlmxsDAcJNCg24yMDCYAQAAAP//Ahn2gYGBwYQCA0H6TBgYGD4AAAAA//+CxeYXqMA5Eg0CqQfp+8LAwMAAAAAA//9CThoggWgSDQOpBxvEwMDAAAAAAP//Qk9nAiQahlDPwMAAAAAA//9CN8yJRMMQ6hkYGAAAAAD//0I3TIZEwxDqGRgYAAAAAP//QjfMFosGUAqvgtLoAKGegYEBAAAA//9CN0wYif2QgYEhiIGBwYqBgaEdSoP4IHFM9QwMDAAAAAD//0I3bDM0v01jYGDQZGBgWI8mD+KDxEHyIHUg9RDAwMAAAAAA//8DAHlhLFQe3TpUAAAAAElFTkSuQmCC" />
                        </defs>
                    </svg>
                    <div class="mt-3 mb-4 text-base text-center md:text-lg xl:text-xl font-ww-regular md:text-left">
                        “Three hours of tunnel-vision focus—every morning.” 
                    </div>
                    <div class="text-base text-center md:text-lg xl:text-xl font-ww-regular md:text-left">– Jason B.</div>
                </article>


            </div>

            <!-- Footnote -->
            <div class="text-base xl:text-lg font-ww-regular">
                *Testimonials reflect individual experiences. Typical users can expect smooth, sustained energy and
                improved focus when used as directed.
            </div>
        </div>
    </section>

</template>
